<template>
  <modal-container :show="show">
    <template slot="body">
      <div class="insurance-wrapper">
        <div class="form-header">
          <div>
            <h2>{{this.$t("choose_ins")}}</h2>
            <p>{{this.$t("choose_ins_txt")}}</p>
          </div>
          <img
            class="cancel"
            src="../../assets/images/Vector (1).png"
            alt="close"
            @click="$emit('close')"
          />
        </div>
        <form @submit.prevent="$emit('choose-insurance', productWorth)">
          <div class="form-group">
            <label>{{ this.$t("total_prod") }}</label>
            <input
              type="number"
              id="totalWorth"
              placeholder="₦ Enter Amount"
              v-model.number="productWorth"
              required
            />
          </div>
          <button type="submit">{{ this.$t("next") }}</button>
        </form>
      </div>
    </template>
  </modal-container>
</template>

<script>
import ModalContainer from "../ModalContainer.vue";
export default {
  components: { ModalContainer },
  name: "ChooseInsurance",
  props: {
    show: Boolean,
    totalItemsPrice: Number,
  },
  data() {
    return {
      productWorth: null,
    };
  },
};
</script>

<style scoped>
.insurance-wrapper {
  background: white;
  padding: 20px;
  border-radius: 10px;
  /* width: 400px;
  max-width: 90%; */
  margin: 0 auto;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding-bottom: 10px;
}

.form-header h2 {
  font-size: 18px;
  font-weight: 600;
}

.cancel {
  cursor: pointer;
  width: 15px;
}

p {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.69px;
  color: rgba(94, 106, 121, 1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  margin-bottom: 5px;
  color: rgba(94, 106, 121, 1);
}

.form-group input {
  width: 100%;
  padding: 10px;
  background-color: rgba(240, 244, 251, 0.6);
  border-radius: 5px;
}

.form-group input::placeholder {
  color: rgba(134, 147, 165, 1);
  font-size: 14px;
  font-weight: 400;
}

button {
  background-color: rgba(33, 62, 122, 1);
  color: white;
  padding: 12px 30px 12px 30px;
  border: none;
  display: block;
  margin-left: auto;
  border-radius: 16px;
}

button:hover {
  background-color: #002266;
}
</style>
